import { z } from "zod"

export interface JuloUpdateReadStatus {
  slug: string
  isManuallyUnread: boolean
}

export interface JuloUpdateReadState {
  readStatuses: JuloUpdateReadStatus[]
  // Stockholm calendar day (YYYY-MM-DD). Entries dated on or after it that the
  // user has never read pop up as a dialog when they open the CRM.
  popUpFromDate: string
}

export const SetJuloUpdateReadStatusSchema = z.object({
  isManuallyUnread: z.boolean(),
})

export type SetJuloUpdateReadStatus = z.infer<
  typeof SetJuloUpdateReadStatusSchema
>

export const MarkAllJuloUpdatesReadSchema = z.object({
  slugs: z.array(z.string().min(1).max(255)),
})

export type MarkAllJuloUpdatesRead = z.infer<
  typeof MarkAllJuloUpdatesReadSchema
>
